/**
 * Microsoft Authentication Library (MSAL) Configuration
 * 
 * This configuration enables multi-tenant Microsoft Azure AD authentication.
 * Users from any Azure AD organization can sign in.
 */

import { Configuration, PopupRequest } from '@azure/msal-browser';

/**
 * MSAL Configuration object
 * For multi-tenant apps, use 'common' as the authority
 */
export const msalConfig: Configuration = {
  auth: {
    clientId: process.env.REACT_APP_AZURE_CLIENT_ID || '',
    authority: 'https://login.microsoftonline.com/common',  // Multi-tenant support
    redirectUri: window.location.origin,
    postLogoutRedirectUri: `${window.location.origin}/login`,
    navigateToLoginRequestUrl: false,
  },
  cache: {
    cacheLocation: 'sessionStorage', // Use sessionStorage for better security
    storeAuthStateInCookie: false,   // Set to true if you have issues with IE11 or Edge
  },
  system: {
    allowNativeBroker: false, // Disable WAM for web apps
    loggerOptions: {
      loggerCallback: (level, message, containsPii) => {
        if (containsPii) {
          return;
        }
        // Log levels: 0=Error, 1=Warning, 2=Info, 3=Verbose
        if (level >= 2) {
          console.log('MSAL:', message);
        }
      },
      logLevel: 2, // Info level logging
    },
  },
};

/**
 * Scopes requested during login
 * These determine what information and permissions the app will have access to
 */
export const loginRequest: PopupRequest = {
  scopes: [
    'User.Read',    // Read user profile
    'openid',       // OpenID Connect authentication
    'profile',      // Basic profile information
    'email',        // Email address
  ],
};

/**
 * Validate that the required environment variables are set
 */
export const validateMsalConfig = (): boolean => {
  if (!process.env.REACT_APP_AZURE_CLIENT_ID) {
    console.error('REACT_APP_AZURE_CLIENT_ID is not set. Microsoft authentication will not work.');
    return false;
  }
  return true;
};
